export default __webpack_public_path__ + "static/media/moneybacklight.b3e96a1d.png";